<template>
  <div class="form_wrapper">
    <base-title v-if="block_data.form_title" :title_level="block_data.title_level" :text="block_data.form_title" :text-align-center="ui.is_mobile_resolution"></base-title>

    <form id="gdpr-form-page" autocomplete="on">
      <div class="wrapper">

        <div class="inputs">
          <!-- left -->
          <div class="wrapper-left">
            <div class="control-group" :class="{ invalid: form.name_validity === 'invalid' }">
              <label for="gdpr-form-name">
                {{ getLabelText('form_name') }}
              </label>
              <input type="text" name="gdpr-form-name" id="gdpr-form-name" v-model.trim="form.name" @blur="validateName">
            </div>
            <div class="control-group" :class="{ invalid: form.phone_number_validity === 'invalid' }">
              <label for="gdpr-form-phone">
                {{ getLabelText('form_phone') }}
              </label>
              <input type="number" name="gdpr-form-phone" id="gdpr-form-phone" v-model.trim="form.phone_number" @blur="validatePhoneNumber">
            </div>
            <div class="control-group" :class="{ invalid: form.email_validity === 'invalid' }">
              <label for="gdpr-form-email">
                {{ getLabelText('form_email') }}
              </label>
              <input type="text" name="gdpr-form-email" id="gdpr-form-email" v-model.trim="form.email" @blur="validateEmail">
            </div>
            <div class="control-group" :class="{ invalid: form.locality_validity === 'invalid' }">
              <label for="gdpr-form-locality">
                {{ getLabelText('form_locality') }}
              </label>
              <input type="text" name="gdpr-form-locality" id="gdpr-form-locality" v-model.trim="form.locality" @blur="validateLocality">
            </div>

            <div class="control-group" :class="{ invalid: form.surface_validity === 'invalid' }">
              <label for="gdpr-form-surface">
                {{ getLabelText('form_surface') }}
              </label>
              <input type="text" name="gdpr-form-surface" id="gdpr-form-surface" v-model.trim="form.surface">
            </div>
          </div>

          <!-- right -->
          <div class="wrapper-right">
            <div class="control-group" :class="{ invalid: form.function_validity === 'invalid' }">
              <label for="gdpr-form-function">
                {{ getLabelText('form_function') }}
              </label>
              <input type="text" name="gdpr-form-function" id="gdpr-form-function" v-model.trim="form.function">
            </div>
            <div class="control-group" :class="{ invalid: form.society_name_validity === 'invalid' }">
              <label for="gdpr-form-name">
                {{ getLabelText('form_society_name') }}
              </label>
              <input type="text" name="gdpr-form-society-name" id="gdpr-form-society-name" v-model.trim="form.society_name">
            </div>
            <div class="control-group content_wrapper" :class="{ invalid: form.county_validity === 'invalid' }">
              <label for="gdpr-form-county">{{ getLabelText('form_county') }}</label>

              <div class="select_wrapper">
                <select v-model="form.county">
                  <option selected value="">{{ custom_fields.choose_county }}</option>
                  <option v-for="(county, county_index) in counties" :key="county_index" :value="county">
                    {{ county }}
                  </option>
                </select>
              </div>
            </div>

            <div class="control-group" :class="{ invalid: form.address_validity === 'invalid' }">
              <label for="gdpr-form-address">
                {{ getLabelText('form_address') }}
              </label>
              <input type="text" name="gdpr-form-address" id="gdpr-form-address" v-model.trim="form.address">
            </div>
          </div>
        </div>

        <div class="cultures-wrapper">
          <p class="form_description">{{ getLabelText('cultures_structure') }}</p>

          <div class="control-group checkboxs-list">
            <div class="checkbox-wrapper" v-for="(culture, index) in cultures_list" @click="showMeasureInput(index)">
              <template v-if="index !== cultures_list.length - 1">
                <label>
                  <input type="checkbox" :value="culture.name" v-model="selectedCultures" />
                  <span class="custom-checkmark"></span>
                </label>
                <span class="checkbox-label">{{ culture.name }}</span>

                <div v-if="selectedCultures.includes(culture.name)">
                  <input class="checkbox-list" type="text" v-model.trim="culture.quantity">
                  <span class="checkbox-label">{{ getLabelText('ha_measure') }}</span>
                </div>
              </template>

              <template v-else>
                <label>
                  <input type="checkbox" :value="culture.name" v-model="selectedCultures" />
                  <span class="custom-checkmark"></span>
                </label>
                <span class="checkbox-label">{{ culture.name }}</span>
                <div v-if="selectedCultures.includes(culture.name)">
                  <input class="checkbox-list others" type="text" v-model.trim="culture.quantity">
                </div>
              </template>
            </div>
          </div>
        </div>

        <div class="control-group">
          <div class="inputs mobile" :class="{ invalid: form.radio_gdpr === 'invalid' }">
            <div class="checkbox-wrapper">
              <label>
                <input type="radio" id="yes" name="form_answer_gdpr" value="yes" v-model="form.radio_gdpr" />
                <span class="custom-checkmark"></span>
              </label>
              <span class="checkbox-label">{{ getLabelText('form_agree') }}</span>
            </div>
            <div class="checkbox-wrapper">
              <label>
                <input type="radio" id="no" name="form_answer_gdpr" value="no" v-model="form.radio_gdpr" />
                <span class="custom-checkmark"></span>
              </label>
              <span class="checkbox-label">{{ getLabelText('form_disagree') }}</span>
            </div>
          </div>
          <label for="gdpr-form-radio-gdpr">
            {{ getLabelText('form_radio_gdpr') }}
          </label>
        </div>

        <div class="control-group">
          <label for="gdpr-form-radio-communication">
            {{ getLabelText('form_radio_comunication') }}
          </label>
          <div class="inputs" :class="{ invalid: form.radio_communication === 'invalid' }">
            <div class="checkbox-wrapper">
              <label>
                <input type="radio" id="yes" name="form_answer_communication" value="yes"  v-model="form.radio_comunication"/>
                <span class="custom-checkmark"></span>
              </label>
              <span class="checkbox-label">{{ getLabelText('form_yes') }}</span>
            </div>
            <div class="checkbox-wrapper">
              <label>
                <input type="radio" id="no" name="form_answer_communication" value="no" v-model="form.radio_comunication"  />
                <span class="custom-checkmark"></span>
              </label>
              <span class="checkbox-label">{{ getLabelText('form_no') }}</span>
            </div>
          </div>
        </div>

        <div class="control-group">
          <label for="gdpr-form-radio-recommandation">
            {{ getLabelText('form_radio_recomandation') }}
          </label>
          <div class="inputs" :class="{ invalid: form.radio_recomandation === 'invalid' }">
            <div class="checkbox-wrapper">
              <label>
                <input type="radio" id="yes" name="form_answer_recommandation" value="yes" v-model="form.radio_recomandation" />
                <span class="custom-checkmark"></span>
              </label>
              <span class="checkbox-label">{{ getLabelText('form_yes') }}</span>
            </div>
            <div class="checkbox-wrapper">
              <label>
                <input type="radio" id="no" name="form_answer_recommandation" value="no" v-model="form.radio_recomandation"/>
                <span class="custom-checkmark"></span>
              </label>
              <span class="checkbox-label">{{ getLabelText('form_no') }}</span>
            </div>
          </div>
        </div>

        <div class="control-group">
          <p class="form_description" v-if="block_data.description" v-html="block_data.description"></p>
        </div>
      </div>

      <div class="control-group">
        <button class="button_submit" @click.prevent="sendEmail">
          {{ block_data.text_button }}
          <arrow-right-svg :color="svg_color" />
        </button>
      </div>

      <Transition name="fade">
        <div v-if="ui.notification_success_visible" class="notification success">
          <p>{{ custom_fields.form_notification_gdpr_success }}</p>
        </div>
        <div v-if="ui.notification_error_visible" class="notification error">
          <p>{{ custom_fields.form_notification_error }}</p>
        </div>
      </Transition>
    </form>
  </div>
</template>

<script>

import axios from 'axios';

import ArrowRightSvg from '../svg-components/ArrowRightSvg.vue';

export default {
  name: 'gdpr-form-page',

  props: ['block_data', 'custom_fields', 'counties'],

  components: { ArrowRightSvg },

  data() {
    return {
      ui: {
        svg_color_desktop: '#2C4E9B',
        svg_color_mobile: '#ffffff',
        is_mobile_resolution: false,
        is_desktop_resolution: false,
        notification_visible: false,
      },

      api_email: '/api/sendEmail',

      form_labels: {},

      form: {
        name: '',
        phone_number: '',
        email: '',
        county: '',
        address: '',
        function: '',
        society_name: '',
        locality: '',
        surface: '',
        radio_gdpr: '',
        radio_comunication: 'yes',
        radio_recomandation: 'yes',
        products: '',

        name_validity: 'pending',
        phone_number_validity: 'pending',
        email_validity: 'pending',
        county_validity: 'pending',
        locality_validity: 'pending',
        message_validity: 'pending',
        privacy_validity: 'pending',
      },

      selectedOption: '',
      activeIndex: null,
      selectedCultures: [],
    }
  },

  computed: {
    svg_color() {
      if (this.ui.is_mobile_resolution) {
        return this.ui.svg_color_mobile;
      } else {
        return this.ui.svg_color_desktop
      }
    },

    formValidity() {
      let form_validity = true;

      if (!this.validateName()) {
        form_validity = false;
      }
      if (!this.validatePhoneNumber()) {
        form_validity = false;
      }
      if (!this.validateEmail()) {
        form_validity = false;
      }
      if (!this.validateCounty()) {
        form_validity = false;
      }

      if (!this.validateLocality()) {
        form_validity = false;
      }

      return form_validity;
    },

    cultures_list() {
      return this.custom_fields.cultures_list
        .split(',')
        .map(culture => ({
          name: culture.trim(),
          quantity: null
        }));
    }
  },

  created() {
    let self = this;

    self.setFormLabels();

    // console.log('block_data', this.block_data, 'custom_fields', this.custom_fields, 'counties', this.counties);
  },

  mounted() {
    let self = this;

    window.addEventListener('resize', self._onResize);
    self._onResize();
  },

  beforeDestroy() {
    window.removeEventListener('resize', this._onResize);
  },

  methods: {
    _onResize: function () {
      this._updateResolutionType();
    },

    _updateResolutionType: function () {

      if (window.innerWidth <= 1024 || (window.innerWidth <= 1024 && window.matchMedia("(orientation: landscape)").matches)) {
        this.ui.is_mobile_resolution = true;
        this.ui.is_desktop_resolution = false;
      } else {
        this.ui.is_mobile_resolution = false;
        this.ui.is_desktop_resolution = true;
      }
    },

    setFormLabels() {
      this.block_data.info.labels.forEach(label => {
        this.form_labels[label.name] = { 'required': label.required }
      })

    },

    getLabelText(label_key) {
      if (typeof this.custom_fields !== 'undefined') {

        let parsed_custom_field = this.custom_fields;
        let label_text = parsed_custom_field[label_key];

        if (this.form_labels[label_key] && this.form_labels[label_key].required) {
          label_text += '*';
        }

        return label_text;
      }
    },

    validateName() {
      if (!this.form_labels.form_name.required) {
        return true;
      }

      if (this.form.name === '') {
        this.form.name_validity = 'invalid';
        return false;
      } else {
        this.form.name_validity = 'valid';
        return true;
      }
    },

    validateCounty() {
      if (!this.form_labels.form_county.required) {
        return true;
      }

      if (this.form.county === '') {
        this.form.county_validity = 'invalid';
        return false;
      } else {
        this.form.county_validity = 'valid';
        return true;
      }
    },

    validateLocality() {
      if (!this.form_labels.form_locality.required) {
        return true;
      }

      if (this.form.locality === '') {
        this.form.locality_validity = 'invalid';
        return false;
      } else {
        this.form.locality_validity = 'valid';
        return true;
      }
    },

    validatePhoneNumber() {
      if (!this.form_labels.form_phone.required) {
        return true;
      }

      if (this.form.phone_number === '') {
        this.form.phone_number_validity = 'invalid';
        return false;
      } else {
        this.form.phone_number_validity = 'valid';
        return true;
      }
    },
    validateEmail() {
      if (!this.form_labels.form_email.required) {
        return true;
      }

      const regex_validate =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (regex_validate.test(this.form.email)) {
        this.form.email_validity = 'valid';
        return true;
      } else {
        this.form.email_validity = 'invalid';
        return false;
      }
    },
    resetForm: function () {
      this.form.name = '';
      this.form.phone_number = '';
      this.form.county = '';
      this.form.email = '';
    },

    showNotification(status) {

      if (status == 'yes') {
        this.ui.notification_success_visible = true;
      } else {
        this.ui.notification_error_visible = true;
      }

      // setTimeout(() => {
      //   this.ui.notification_visible = false;
      // }, 5000)
    },


    buildSelectedProducts() {
      this.form.products = JSON.stringify(
        this.cultures_list
          .filter(culture => this.selectedCultures.includes(culture.name))
          .map(culture => ({
            name: culture.name,
            quantity: culture.quantity == null ? '1' : culture.quantity
          }))
      );
    },

    sendEmail: function () {
      let self = this;

      self.buildSelectedProducts();

      if (!this.formValidity) {
        return;
      }

      const form_type = self.block_data.info.type;

      const form_payload = {
        type: form_type,
        name: self.form.name,
        phone: self.form.phone_number,
        email: self.form.email,
        county: self.form.county,
        address: self.form.address,
        function: self.form.function,
        society_name: self.form.society_name,
        locality: self.form.locality,
        surface: self.form.surface,
        radio_gdpr: self.form.radio_gdpr,
        radio_comunication: self.form.radio_comunication,
        radio_recomandation: self.form.radio_recomandation,
        products: self.form.products,
      }

      const form_data = new FormData();

      for (let form_key in form_payload) {
        form_data.append(form_key, form_payload[form_key]);
      }

      const email_api_url = self.api_email;

      if (self.form.radio_gdpr == 'yes') {
        axios({
          method: 'post',
          url: email_api_url,
          data: form_data,
          headers: { "Content-Type": "multipart/form-data" }

        }).then((response) => {
          console.log('Send default form to email response - ', response);

          if (response.data.success === 'success') {
            console.log('success');

            self.showNotification(self.form.radio_gdpr);
            self.resetForm();

          } else {
            console.log('api error');
          }

        }).catch(error => {
          console.log('Could not perform send email post - ', error);
          console.log('Api error.response.data - ', error.response.data)

          const errors = error.response.data.errors;

          if (errors) {
            if (errors.form_attachment_file) {
              self.form.file_validity = 'invalid';
            }
          }
        });
      } else {
        self.showNotification(self.form.radio_gdpr);
        self.selectedCultures = [];
        self.resetForm();
      }

    },

    showMeasureInput(index) {
      var self = this;

      self.activeIndex = index;
    }

  },
}
</script>

<style lang="scss" scoped>
.form_wrapper {
  width: 100%;

  #gdpr-form-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;

    .wrapper,
    .wrapper-left,
    .wrapper-right {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 20px;

      .inputs {
        display: flex;
        gap: 20px;

        @media (max-width: 1023px) {
          flex-direction: column;
        }

        &.mobile {
          @media (max-width: 1023px) {
            flex-direction: row;
          }
        }
      }
    }

    .control-group {
      display: flex;
      flex-direction: column;
      width: 100%;
      gap: 20px;

      @media (max-width: 1023px) {
        gap: 10px;
      }

      &.invalid {

        input,
        textarea {
          border: 1px solid var(--red);
        }

        .select_wrapper {
          select {
            border: 1px solid var(--red) !important;
          }
        }

      }

      &.privacy {
        flex-direction: row;

      }

      label {
        font-size: 16px;
        line-height: 18px;
        font-family: inherit;
        color: #333;
        font-weight: bold;

        @media (min-width: 1024px) {
          font-size: 18px;
          line-height: 21px;
        }

        ::v-deep a {
          text-decoration: underline;
        }

        a {
          text-decoration: underline;
        }
      }

      input {
        width: 100%;
        padding: 10px;

        border-radius: 10px;
        border: 1px solid #333;
        background: #FFF;

        font-size: 16px;
        font-family: inherit;
        transition: all 0.3s ease-in-out;

        &:focus,
        &:focus-visible {
          outline: none;
        }

        @media (min-width: 1024px) {
          font-size: 18px;
        }
      }

      .form_info,
      .form_description {
        font-size: 16px;
        line-height: 18px;
        font-family: inherit;
        color: #000;

        @media (min-width: 1024px) {
          font-size: 18px;
          line-height: 21px;
        }

        ::v-deep ul {
          margin-left: 25px;
        }
      }

      .form_info {
        font-weight: bold;
      }

      .checkbox-wrapper {
        position: relative;
        display: flex;
        align-items: center;
        gap: 10px;
        width: fit-content;

        &.checked {
          font-weight: bold;
        }
      }

      .checkbox-wrapper input[type="radio"],
      .checkbox-wrapper input[type="checkbox"] {
        position: absolute;
        opacity: 0;
        width: 0;
        height: 0;
      }

      .custom-checkmark {
        display: inline-block;
        width: 26px;
        height: 26px;
        background: #fff;
        outline: 1px solid #333333;
        box-sizing: border-box;
        position: relative;
        border-radius: 10px;
        cursor: pointer;

        @media (max-width: 1023px) {
          width: 22px;
          height: 22px;
        }
      }

      .checkbox-wrapper input[type="radio"]:checked+.custom-checkmark,
      .checkbox-wrapper input[type="checkbox"]:checked+.custom-checkmark {
        background: var(--text_color);
        outline: 3px solid var(--text_color);
      }

      .checkbox-wrapper input[type="radio"]:checked+.custom-checkmark::after,
      .checkbox-wrapper input[type="checkbox"]:checked+.custom-checkmark::after {
        content: "";
        position: absolute;
        left: 7px;
        top: 1px;
        width: 10px;
        height: 19px;
        border: solid #fff;
        border-width: 0px 4px 5px 0;
        transform: rotate(45deg);

        @media (max-width: 1023px) {
          left: 6px;
          top: 3px;
          width: 9px;
          height: 14px;
        }
      }

      .checkbox-label {
        flex: 1;
        margin-bottom: 0;
        font-size: 20px;
        font-weight: 500;
        line-height: 20px;

        @media (max-width: 1023px) {
          font-size: 14px;
          line-height: 22px;
        }
      }

      &.checkboxs-list {
        width: fit-content;

        .checkbox-label {
          font-weight: normal;
        }

        .checkbox-list {
          width: 50px;
          border-radius: 2px;
          border: none;
          border-bottom: 1px solid #333;
          text-align: center;
          padding: 0;

          &.others {
            width: 150px;
          }
        }

        .checkbox-list+.checkbox-label {
          margin-left: 0;
        }
      }

      textarea {
        width: 100%;
        min-height: 204px;
        padding: 10px;

        resize: vertical;

        border-radius: 10px;
        border: 1px solid #333;
        background: #FFF;

        font-size: 16px;
        font-family: inherit;
        transition: all 0.3s ease-in-out;

        &:focus,
        &:focus-visible {
          outline: none;
        }

        @media (min-width: 1024px) {
          font-size: 18px;
        }
      }

      .privacy_checkbox {
        appearance: none;
        display: grid;
        place-content: center;
        width: 26px;
        height: 26px;
        margin: 0 auto;
        border: 1px solid #333;
        border-radius: 10px;
        background-color: #fff;
        color: #333;
        cursor: pointer;

        &::before {
          content: "";
          width: 15px;
          height: 13px;
          -webkit-clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
          clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
          transform: scale(0);
          transform-origin: center;
          transition: 120ms transform ease-in-out;
          box-shadow: inset 1em 1em var(--text_color);
        }

        &:checked::before {
          transform: scale(1);
        }
      }

      .button_submit {
        display: flex;
        padding: 5px 10px;
        align-items: center;
        width: fit-content;
        margin-top: 30px;
        gap: 5px;
        border-radius: 10px;
        border: 1px solid var(--text_color);
        background: var(--text_color);
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;

        @media (min-width: 1024px) {
          padding: 10px 50px;
          background: #fff;
          color: var(--text_color);
          font-size: 18px;
          margin-bottom: 30px;
          cursor: pointer;
        }
      }

      &.content_wrapper {
        margin-bottom: 0 !important;

        .select_wrapper {
          width: 100%;

          select {
            border-radius: 10px;
            border: 1px solid #333;
            padding: 10px;
            width: 100%;
            color: #333;
            font-style: normal;
            font-size: 16px;
            letter-spacing: 0.64px;
            font-weight: 400;
            line-height: normal;

            @media (min-width: 1024px) {
              font-size: 18px;
              letter-spacing: 0.72px;
            }
          }
        }

        .cards_wrapper {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 20px;

          @media (min-width: 1024px) {
            justify-content: unset;
          }
        }

        .no_cards_wrapper {
          p {
            text-align: center;
          }
        }
      }
    }

    .cultures-wrapper {
      margin-bottom: 60px;
      display: flex;
      flex-direction: column;
      gap: 10px;

      @media (max-width: 1023px) {
        margin-bottom: 30px;
      }
    }
  }

  .notification {
    margin-bottom: 40px;
    padding: 10px;
    text-align: center;
    width: 100%;

    p {
      color: #FFF;
      text-align: center;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      letter-spacing: 0.72px;
    }

    &.success {
      background-color: #62AF1D;
    }

    &.error {
      background-color: var(--red);
    }
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: all 0.3s ease-in-out;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>